import React from 'react';
import Icon from '../../../components/AppIcon';

const RoomInsights = ({ rooms }) => {
  const totalRooms = rooms.length;
  const maintenanceRooms = rooms.filter(room => room.status === 'MAINTENANCE').length;
  const occupiedRooms = rooms.filter(room => room.status === 'OCCUPIED').length;
  
  // Taxa de ocupação REAL baseada em reservas ativas
  const roomsWithActiveReservations = rooms.filter(room => 
    room.reservations && room.reservations.length > 0
  ).length;
  
  const occupancyRate = totalRooms > 0 ? 
    ((occupiedRooms + roomsWithActiveReservations) / totalRooms * 100).toFixed(1) : 0;
  
  const averagePrice = totalRooms > 0 ? 
    (rooms.reduce((sum, room) => sum + parseFloat(room.couplePrice || 0), 0) / totalRooms).toFixed(2) : 0;

  const formatPrice = (price) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(price);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow">
      <h3 className="text-lg font-semibold text-foreground mb-4">Insights Rápidos</h3>
      <div className="space-y-3">
        <div className="flex items-center space-x-3 p-3 bg-muted/30 rounded-lg">
          <Icon name="AlertCircle" size={20} color="var(--color-warning)" />
          <div className="flex-1">
            <p className="text-sm font-medium text-foreground">
              {maintenanceRooms} quartos em manutenção
            </p>
            <p className="text-xs text-muted-foreground">
              Verifique o cronograma de manutenção preventiva
            </p>
          </div>
        </div>
        
        <div className="flex items-center space-x-3 p-3 bg-muted/30 rounded-lg">
          <Icon name="TrendingUp" size={20} color="var(--color-success)" />
          <div className="flex-1">
            <p className="text-sm font-medium text-foreground">
              Taxa de ocupação: {occupancyRate}%
            </p>
            <p className="text-xs text-muted-foreground">
              {occupancyRate > 80 ? 'Excelente performance' : 'Oportunidade de melhoria'}
            </p>
          </div>
        </div>
        
        <div className="flex items-center space-x-3 p-3 bg-muted/30 rounded-lg">
          <Icon name="DollarSign" size={20} color="var(--color-primary)" />
          <div className="flex-1">
            <p className="text-sm font-medium text-foreground">
              Receita potencial: {formatPrice(totalRooms * parseFloat(averagePrice) * 30)}
            </p>
            <p className="text-xs text-muted-foreground">
              Baseado na ocupação total mensal
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomInsights;
